import { useMemo } from 'react';
import { Box, type BoxT } from '@mentimeter/ragnar-ui/box';

export const TextSkeleton = ({
  isVisible,
  shouldAnimate,
  color,
}: {
  isVisible: boolean;
  shouldAnimate: boolean;
  color: BoxT['bg'];
}) => {
  // Only randomize once, 20-70%
  const randomWidth = useMemo(() => Math.floor(Math.random() * 50) + 20, []);

  return (
    <Box
      position="absolute"
      top="0"
      left="0"
      width="100%"
      display="flex"
      flexDirection="row"
      flexWrap="wrap"
      gap="2%"
      style={{
        opacity: isVisible ? 1 : 0,
        transition: shouldAnimate ? 'opacity 0.2s ease' : 'none',
      }}
    >
      <Box
        width={`${randomWidth}%`}
        height="1.5em"
        borderRadius="xl"
        bg={color}
      />
      <Box
        width={`${95 - randomWidth}%`}
        height="1.5em"
        borderRadius="xl"
        bg={color}
      />
    </Box>
  );
};
